import { apiClient } from './client';
import type { ApiSuccess } from '../types';

export interface BulkRowResult {
  row: number;
  name: string;
  outcome: 'created' | 'error';
  code?: string;
  loginEmail?: string;
  temporaryPassword?: string;
  message?: string;
}

export interface BulkResult {
  entity: string;
  total: number;
  created: number;
  failed: number;
  loginsCreated: number;
  results: BulkRowResult[];
}

type Row = Record<string, unknown>;

export const bulkOnboardApi = {
  async dealers(rows: Row[], createLogins: boolean): Promise<BulkResult> {
    return (await apiClient.post<ApiSuccess<BulkResult>>('/bulk-onboard/dealers', { rows, createLogins })).data.data;
  },
  async clients(rows: Row[], createLogins: boolean): Promise<BulkResult> {
    return (await apiClient.post<ApiSuccess<BulkResult>>('/bulk-onboard/clients', { rows, createLogins })).data.data;
  },
};
